import ManagePortionMap from './ManagePortionMap'

export default ManagePortionMap
